import { merge } from "lodash"
import { makeDefaultMaterialRoute } from "@common/router/utils"

import ArchiveWrapper from "@wrappers/ArchiveWrapper.vue"
import DocumentListWrapper from "@wrappers/DocumentListWrapper.vue"

export default function(material, { highlight = false, isPublic = false, path = null } = {}) {
  return merge({}, makeDefaultMaterialRoute(material), {
    path: path !== null ? path : "oikeuskaytanto",
    children: [
      {
        path: "",
        name: "caseLaw.index",
        component: DocumentListWrapper,
        meta: {
          title: "heading.caseLaw.index",
          isPublic: !!isPublic,
        },
      },
      {
        path: "vuosihakemisto/:year(\\d{4})?",
        name: "caseLaw.archive",
        component: ArchiveWrapper,
        meta: { title: "heading.caseLaw.archive" },
      },
    ],
    highlightItem: highlight,
  })
}
